// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"6cdd1d21","549":"9891c5ff","669":"96c96e95","717":"eb6deb64","754":"13e5b413","972":"38ef82d8"}[chunkId] + ".chunk.css";
};